export class notification {
    constructor(message: string, createdOn: Date, createdBy: string) {
        this.message = message;
        this.createdBy = createdBy;
        this.createdOn = createdOn;
    }
    message: string;
    createdOn: Date;
    createdBy: string;
}